
import { defineComponent, reactive, ref } from 'vue'
import { getContent } from '@/api'
import { UserInfo } from '@/store/index'
export interface CarouselItem {
  url: string;
  name?: string;
}
export interface RecentCarousel {
  ratingsAverage: number;
  ratingsity?: number;
  images?: string[];
  _id: string;
  created: string;
  title: string;
  article: string;
  photo: string;
  author: UserInfo;
  slug: string;
  duration?: null;
  id: string;
  category?: string;
}
export default defineComponent({
  async setup () {
    const carouselContent = reactive({ data: [] as RecentCarousel[] })
    const carouselIndex = ref(0)
    // const carousel = reactive({
    //   carouselArr: [
    //     {
    //       url: 'https://images.unsplash.com/photo-1615865417491-9941019fbc00?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    //       id: 0,
    //       title: 'rice',
    //       text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit ipsa ab qui natus nam ipsum, tempore laborum iste ea. In nihil repellat fugiat! Sint explicabo eius voluptatibus corporis illo consequatur.',
    //       author: {
    //         name: 'Lynn',
    //         image: 'https://i.imgur.com/J9DkbOj.png'
    //       }
    //     },
    //     {
    //       url: 'https://images.unsplash.com/photo-1574766777271-cf399aebb82e?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80',
    //       id: 1,
    //       title: 'croissant',
    //       text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit ipsa ab qui natus nam ipsum, tempore laborum iste ea. In nihil repellat fugiat! Sint explicabo eius voluptatibus corporis illo consequatur.',
    //       author: {
    //         name: 'Lann',
    //         image: 'https://i.imgur.com/ZhhA0LG.png'
    //       }
    //     },
    //     {
    //       url: 'https://images.unsplash.com/photo-1584359246637-a53c74bf8905?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    //       id: 2,
    //       title: 'bread',
    //       text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit ipsa ab qui natus nam ipsum, tempore laborum iste ea. In nihil repellat fugiat! Sint explicabo eius voluptatibus corporis illo consequatur.',
    //       author: {
    //         name: 'Vella',
    //         image: 'https://i.imgur.com/FWcLGNn.png'
    //       }
    //     },
    //     {
    //       url: 'https://images.unsplash.com/photo-1607919564479-c2e00f3b14a9?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2134&q=80',
    //       id: 3,
    //       title: 'cookies',
    //       text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit ipsa ab qui natus nam ipsum, tempore laborum iste ea. In nihil repellat fugiat! Sint explicabo eius voluptatibus corporis illo consequatur.',
    //       author: {
    //         name: 'Vella',
    //         image: 'https://i.imgur.com/FWcLGNn.png'
    //       }
    //     },
    //     {
    //       url: 'https://images.unsplash.com/photo-1548586832-45302f8374ea?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1417&q=80',
    //       id: 4,
    //       title: 'egg tart',
    //       text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit ipsa ab qui natus nam ipsum, tempore laborum iste ea. In nihil repellat fugiat! Sint explicabo eius voluptatibus corporis illo consequatur.',
    //       author: {
    //         name: 'Vella',
    //         image: 'https://i.imgur.com/FWcLGNn.png'
    //       }
    //     }
    //   ]
    // })
    const carouselControl = (move: number) => {
      carouselIndex.value = (carouselIndex.value + move + carouselContent.data.length) % carouselContent.data.length
    }
    const { data } = await getContent(1, 5)
    carouselContent.data = data.data
    return {
      // carousel,
      carouselIndex,
      carouselControl,
      carouselContent
    }
  }
})
